import React from "react";
import { Phone } from "lucide-react";
import { GemMark, scrollToId } from "./Reveal";

const links = [
    { id: "about", label: "Our Story" },
    { id: "collections", label: "Collections" },
    { id: "founder", label: "Kunal Diwakar" },
    { id: "contact", label: "Contact" },
];

export default function Nav() {
    return (
        <header
            data-testid="nav-bar"
            className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-obsidian/80 border-b border-gold/20"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
                <button
                    data-testid="nav-logo"
                    onClick={() => scrollToId("hero")}
                    className="flex items-center gap-3 group"
                >
                    <GemMark size={28} />
                    <span className="text-left leading-tight">
                        <span className="block font-display text-lg tracking-wide text-ivory group-hover:text-gold-light transition-colors">
                            Maa Gayatri Jewellers
                        </span>
                        <span className="block text-[10px] tracking-[0.3em] uppercase text-muted">
                            Supaul · Bihar
                        </span>
                    </span>
                </button>

                <nav className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => scrollToId(l.id)}
                            className="text-[13px] tracking-wide text-clay hover:text-gold-light transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <a
                    href="tel:7209661797"
                    data-testid="call-now-button"
                    className="flex items-center gap-2 border border-gold/40 hover:border-gold-light hover:shadow-[0_0_30px_rgba(212,175,55,0.25)] transition-all duration-300 px-4 sm:px-5 py-2.5 text-[13px] font-semibold tracking-wide text-gold-light"
                >
                    <Phone size={14} strokeWidth={2.2} />
                    <span className="hidden sm:inline">Call: 7209661797</span>
                    <span className="sm:hidden">Call</span>
                </a>
            </div>
        </header>
    );
}
